define.alias("shared/components/shared/mavely/links/folders-tab", "preview-grid/components/shared/mavely/links/folders-tab");